export default __webpack_public_path__ + "static/media/pirate.523d6308.svg";